import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { FaPlug, FaWifi } from "react-icons/fa";
import { MdWifiOff } from "react-icons/md";

import StatCard from "../StatCard";
import NoDevice from "../NoDevice";
import { ADMIN_STATS_API } from "../../api/apiroutes";
import Loader from "../Loader";
const DeviceStats = () => {
  const token = useSelector((state) => state.user.token);

  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) fetchStats();
  }, [token]);

  const fetchStats = async () => {
  try {
    const res = await axios.get(ADMIN_STATS_API.DEVICE_STATS, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-client-type": "web",
        "Content-Type": "application/json",
  
      },
    });

    // Normalize empty array to default object
    const data = Array.isArray(res.data.data) && res.data.data.length === 0
      ? { totalDevices: 0, byType: {}, online: 0, offline: 0, unknown: 0 }
      : res.data.data;

    setStats(data);
  } catch (err) {
    console.error("Failed to fetch device stats", err);
    setStats({ totalDevices: 0, byType: {}, online: 0, offline: 0, unknown: 0 });
  } finally {
    setLoading(false);
  }
};


  if (loading)
    return (
      <Loader/>
    );

  if (!stats || stats.totalDevices === 0) return <NoDevice />;

  return (
    <div className="space-y-4">
      {/* Summary Cards */}
      <div className="grid grid-cols-4 gap-4">
        <StatCard
          title="Total Devices"
          value={stats.totalDevices}
          icon={<FaPlug />}
        />
        <StatCard title="Online" value={stats.online} icon={<FaWifi />} green />
        <StatCard
          title="Offline"
          value={stats.offline}
          icon={<MdWifiOff />}
          red
        />
        <StatCard title="Unknown" value={stats.unknown} />
      </div>

      {/* Device Types */}
      <div className="bg-white rounded-xl shadow p-4">
        <h3 className="font-semibold mb-3 text-gray-700">Devices by Type</h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {Object.entries(stats.byType || {}).map(([type, count]) => (
            <div
              key={type}
              className="group bg-gray-50 rounded-lg p-3 text-center cursor-pointer
                         transition-all duration-300 hover:bg-indigo-50
                         hover:shadow-md hover:-translate-y-1"
            >
              <p className="text-sm text-gray-500 group-hover:text-indigo-600">
                {type.toUpperCase()}
              </p>
              <p className="text-2xl font-bold text-gray-800 group-hover:text-indigo-700">
                {count}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeviceStats;
